import React from 'react';
import Header from '../components/Header/Header';
import CoffeeProducts from '../components/CoffeeProducts/CoffeeProducts';
import Footer from '../components/Footer/Footer';

const ShopPage = () => {
  return (
    <>
      <Header />
      <CoffeeProducts />
      <Footer />
    </>
  );
};

export default ShopPage;
